import useJwt from "@src/@core/auth/jwt/useJwt";

// TODO: Momentaneamente desabilitado!
// eslint-disable-next-line react-hooks/rules-of-hooks
const { jwt } = useJwt({});

export default jwt;
